import { keepPreviousData, useQuery } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'

export interface GetGiftCardsRequest {
  buildingId?: number
  skip?: number
  limit?: number
  type?: string
  category?: string
  status?: string
  query?: string
  clientId?: number[]
}

// Note: kept as a loose/untyped passthrough (matches what RewardsGiftDetailsModal.jsx and
// helpers.jsx's `columns()` already expect at runtime) rather than a fully-typed model - this is
// the exact same raw row shape the legacy `fetchRewardsHistory` Redux thunk has always returned,
// just fetched via React Query instead.
// biome-ignore lint/suspicious/noExplicitAny: see note above
export type GiftCardModel = Record<string, any>

export interface GetGiftCardsResponse {
  data: GiftCardModel[]
  count: number
}

export const GET_GIFT_CARDS_BASE_QUERY_KEY = 'useGetGiftCards'

export const getGiftCardsQueryKey = (data: GetGiftCardsRequest) => [
  GET_GIFT_CARDS_BASE_QUERY_KEY,
  data,
]

export const getGiftCards = async (
  data: GetGiftCardsRequest,
  signal?: AbortSignal,
): Promise<GetGiftCardsResponse> => {
  const response = await authAPI.get<GetGiftCardsResponse>('/reward/history', {
    params: data,
    signal,
  })
  return response.data
}

export const useGetGiftCards = (data: GetGiftCardsRequest) => {
  return useQuery({
    enabled: !!data.buildingId,
    placeholderData: keepPreviousData,
    queryFn: ({ signal }) => getGiftCards(data, signal),
    queryKey: getGiftCardsQueryKey(data),
  })
}
